module.exports = __webpack_public_path__ + "static/media/fancy_5_bottom.2a0f0d6c.svg";